import styled from "@emotion/styled";
import { Radio, Typography } from "@mui/material";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import DefaultTextBold from "../../../../components/Accessibility/DefaultTextBold";
import { PerguntaItem } from "../../../../interfaces/entities/SaudeBemEstar/AutoAvaliacao/PerguntaItem";
import { useId } from "react";

interface Props {
  selected: number | undefined;
  onSelected?: (idPergunta: string, indexResposta: number) => void;
  data: PerguntaItem;
  readOnly?: boolean;
}

const AutoAvaliacaoPergunta: React.FC<Props> = ({
  selected,
  onSelected,
  data,
  readOnly,
}) => {
  const { contrastMode, contrastColor, textStyleAccessibility } =
    useAccessibility();

  const id = useId();

  const StyledRadio = styled(Radio)(() => ({
    color: contrastMode ? "white" : "#A5A5A5",
    "&.Mui-checked": {
      color: contrastMode ? contrastColor : "#00995D",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "40px",
    },
    "& .MuiRadio-root": {
      borderWidth: "1px",
    },
    ...(readOnly && {
      "&:hover": {
        backgroundColor: "transparent",
      },
      pointerEvents: "none",
    }),
  }));

  const onClick = (idPergunta: string, indexResposta: number) => {
    if (!readOnly && onSelected) {
      onSelected(idPergunta, indexResposta);
    }
  };

  return (
    <>
      <DefaultTextBold component="h2" text={data.txtQuestao} />
      <fieldset aria-labelledby={id + "-question-group"} className="pergunta-options-container">
        <legend style={{display: 'none'}} id={id + "-question-group"}>{data.txtQuestao}</legend>
        {data.lstQuestoesTriagem.map((pergunta, i) => (
          <div
            tabIndex={readOnly ? -1 : 0}
            key={`option-${i}`}
            aria-label={pergunta.txtItemQuestao}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick(data.idQuestaoTeleOrient, i);
              }
            }}
          >
            <StyledRadio
              tabIndex={-1}
              checked={
                !readOnly ? selected === i : parseInt(data.resposta) === i
              }
              onClick={() => {
                onClick(data.idQuestaoTeleOrient, i);
              }}
              disabled={readOnly}
            />
            <Typography
              align="center"
              style={textStyleAccessibility}
              component={"h2"}
              fontSize="12px"
              color="#4C4C4C"
            >
              {pergunta.txtItemQuestao}
            </Typography>
          </div>
        ))}
      </fieldset>
    </>
  );
};

export default AutoAvaliacaoPergunta;
